<div class="container" [attr.data-testid]="'reset-password-dialog-container'">
  <mat-icon [attr.data-testid]="'reset-password-warning-icon'"
    >warning</mat-icon
  >

  <h6 class="title" [attr.data-testid]="'reset-password-dialog-title'">
    {{ title }}
  </h6>

  <p class="content" [attr.data-testid]="'reset-password-dialog-content'">
    {{ content }}
  </p>

  <div class="buttons" [attr.data-testid]="'reset-password-dialog-buttons'">
    <button
      mat-raised-button
      color="primary"
      (click)="submit()"
      [attr.data-testid]="'reset-password-submit-button'"
    >
      {{ confirm }}
    </button>
  </div>
</div>
